import type { FC } from 'react';
import React from 'react';

import type { THeading } from './models';

export const Heading: FC<THeading> = ({ Aligner, Text, heading, isMobile }) => {
    if (!heading?.text) return null;

    const align = heading.align || 'left';
    const view = heading.view || (isMobile ? 'medium' : 'large');

    return (
        <Aligner align={align} styler={{ marginBottom: isMobile ? 24 : 32 }}>
            <Text styler={{ margin: 0 }} view={view}>
                {heading.text}
            </Text>
        </Aligner>
    );
};
